/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ portal: NonNullable<unknown>, level: NonNullable<unknown> }} Portals_Matrix_MissingInputs */

const cs_portals_matrix_missing = /** @type {(inputs: Portals_Matrix_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.portal}: chybí (${i?.level})`)
};

const en_portals_matrix_missing = /** @type {(inputs: Portals_Matrix_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.portal}: missing (${i?.level})`)
};

/**
* | output |
* | --- |
* | "{portal}: missing ({level})" |
*
* @param {Portals_Matrix_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_missing = /** @type {((inputs: Portals_Matrix_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_missing(inputs)
	return cs_portals_matrix_missing(inputs)
});